export default __webpack_public_path__ + "static/media/arrow.9c284194.svg";